/**
 * index.js
 * Tatalli Cloud — Uygulama Giriş Noktası
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

// 1. Kütüphane stilleri
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'remixicon/fonts/remixicon.css';

// 2. Uygulama stilleri (kütüphane stillerini ezer)
import './index.css';

// 3. Bileşenler ve yapılandırma
import App from './App';
import './i18n';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Router
    future={{
      v7_startTransition     : true,
      v7_relativeSplatPath   : true,
    }}
  >
    <App />
  </Router>
);

reportWebVitals();
